import { useNavigate } from 'react-router';
import login_Service from '../../../api/services/login_Service';
import { useEffect, useState } from 'react';
import forwardArrow from "../../../assets/icons/forward.svg";
import Modal from "../../common/components/modal/index";
import { useDispatch } from 'react-redux';
import { playSong } from '../../common/actions/common.actions';
import { IoIosArrowBack } from "react-icons/io";

const Rules = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rules, setRules] = useState([]);
  const queryParams = new URLSearchParams(window.location.search);
  const loggedInParam = queryParams.get("loggedIn");
  const loggedIn = loggedInParam === "true";
  const [isModalOpen, setIsModalOpen] = useState(true);

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleClick = () => {
    handleSongClick();
    navigate('/dashboard');
  };

  const handleButtonClick = (redirectToDashboard) => {
    if (redirectToDashboard) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    setIsLoading(true);
    login_Service.rule()
      .then(response => response.json())
      .then(data => {
        if (data) {
          setRules(data)
          setIsLoading(false);
        }
      })
      .catch(err => {
        console.log(err)
      });
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="flex flex-col py-4 justify-between h-[100dvh] w-full bg-white font-myanmarSansPro dark:bg-background bg-opacity-90 overflow-hidden">
      <div className="flex pt-4 justify-start items-start">
        <button
          className="left-10 w-10 h-10 mr-3 rounded-full drop-shadow-lg flex justify-start items-start text-blue-700 text-4xl"
          onClick={handleClick}
        >
          {/* {loggedInParam ? '' : <img src={forwardArrow} alt="Back Arrow" />} */}
          {loggedInParam ? '' : <IoIosArrowBack size={25} className="text-content ml-2" />}
        </button>
        <div className="flex flex-1 justify-center items-center font-inter font-bold text-primary dark:text-white text-2xl font-400 -ml-6">
          Rule & Regulation
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-3 py-2 space-y-1">
        {rules.map((rule) => (
          <div
            key={rule.ruleId}
            className="rounded-xl border border-slate-200 dark:border-slate-700 
                 bg-white dark:bg-slate-900 
                 p-4 shadow-sm hover:shadow-md transition"
          >
            <h3 className="text-base font-inter font-semibold text-slate-800 dark:text-white mb-2">
              {rule?.ruleTitle}
            </h3>

            <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
              {rule?.descriptions}
            </p>
          </div>
        ))}
      </div>

      {loggedIn && (
        <div className=" z-50 w-full h-20">
          <div className="flex justify-end items-end md:justify-center space-x-4 p-4">
            <button
              onClick={() => handleButtonClick(false)}
              className="relative rounded-[7px] p-[1px] bg-gradient-to-r from-text_rule_btn via-orange-400 to-red-300"
            >
              <span className="block rounded-[6px] px-6 py-2 bg-slate-100 dark:bg-slate-900 text-text_rule_btn">
                ထွက်မည်
              </span>
            </button>

            <button
              onClick={() => handleButtonClick(true)}
              className="relative rounded-[7px] p-[1px] bg-gradient-to-r from-content via-emerald-500 to-cyan-500"
            >
              <span className="block rounded-[6px] px-6 py-2  bg-slate-100 dark:bg-slate-900 text-content">
                သဘောတူပါသည်
              </span>
            </button>

          </div>
        </div>
      )}
      {/* {isModalOpen && loggedIn && (
        <Modal title="SPORT 909" content="Login Success" onClose={closeModal} />
      )} */}
    </div>
  );
};

export default Rules;
